import { Box, TextField, styled } from '@mui/material'
import { useAppSelector } from 'app/state'
import { getEnrichedDatasetById } from 'features/builder/state/keplerGlSlice'
import useDatasetsLetters from 'features/builder/state/useDatasetsLetters'
import { FormattedMessage } from 'react-intl'

const Letter = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color'
})<{
  color?: string
}>(({ color, theme }) => ({
  display: 'flex',
  height: theme.spacing(2),
  width: theme.spacing(2),
  flex: `0 0 ${theme.spacing(2)}`,
  borderRadius: theme.spacing(0.25),
  color: theme.palette.common.white,
  justifyContent: 'center',
  fontSize: theme.spacing(1.5),
  marginRight: theme.spacing(0.5),
  backgroundColor: color ? `rgb(${color})` : theme.palette.text.secondary
}))

const TextFieldInput = styled(TextField)(() => ({
  '& .Mui-disabled:hover': {
    cursor: 'not-allowed'
  }
}))

function BaseSource() {
  const letters = useDatasetsLetters()
  const sourceDatasetId = useAppSelector((state) => state.analysis.sourceDatasetId)
  const dataset = useAppSelector((state) => getEnrichedDatasetById(state, sourceDatasetId as string))

  return (
    <TextFieldInput
      label={<FormattedMessage id="analysis.intersect.base" />}
      variant="outlined"
      size="small"
      value={dataset?.label || 'Loading...'}
      InputProps={{
        'aria-label': 'Base source select',
        startAdornment: <Letter color={dataset?.color}>{dataset && letters[dataset.id]}</Letter>
      }}
      disabled
    />
  )
}

export default BaseSource
